import { createHook, createStore } from 'react-sweet-state'
import { ThemeModes } from 'theme/theme'

const Store = createStore({
    initialState: {
        globalTheme: {
            fontSize: '62.5%',
            mode: ThemeModes.LIGHT,
        },
    },

    actions: {
        setFontSize:
            (fontSize) =>
            ({ setState, getState }) =>
                setState({
                    globalTheme: {
                        ...getState().globalTheme,
                        fontSize: fontSize,
                    },
                }),

        setTheme:
            (mode) =>
            ({ setState, getState }) =>
                setState({
                    globalTheme: {
                        ...getState().globalTheme,
                        mode,
                    },
                }),
    },

    name: 'globalThemeStore',
})

export const useGlobalThemeStore = createHook(Store)
